import { pickBy, omit, uniqBy } from 'lodash-es';
import { FILTER_OPERATOR_ENUMS, FILTER_RULE_ENUMS } from '@constants';
import { formatDate, removeHtmlTags } from '@utils';
import { SIDE_FILTERS_ENUM } from 'components/communication/CommunicationSideBar/constants';
import { handleEmailListViewDate } from './emailUtils';

export const labelsMap = {
  [SIDE_FILTERS_ENUM.Inbox]: ['inbox'],
  [SIDE_FILTERS_ENUM.Sent]: ['sent'],
  [SIDE_FILTERS_ENUM['Contact Form']]: ['label_2690784046402531814'],
  [SIDE_FILTERS_ENUM['Get Accept']]: ['label_1721635861577314959'],
  [SIDE_FILTERS_ENUM.B2B]: ['label_7242129306205049882'],
  [SIDE_FILTERS_ENUM['Buy Contact Form']]: ['label_3209279607429980771'],
  [SIDE_FILTERS_ENUM.BoxNow]: ['label_8595956168573002351'],
  [SIDE_FILTERS_ENUM['Delivery Failures']]: ['label_6379763018692781731'],
  [SIDE_FILTERS_ENUM.Automated]: ['label_4490735335154174772'],
};

export const getAllDisplayEmailAddress = (data) => {
  const emailAddress = [{ ...data.from, type: 'sender' }];
  data.to?.forEach?.((item) =>
    emailAddress.push({ ...item, type: 'receiver' })
  );

  return uniqBy(emailAddress, 'emailAddress');
};

export const computeEmailListPayload = (queryParams = {}) => {
  let payload = localStorage.communicationQuery; // This storage contains the values of filter modals
  let unifiedViewFilterRules = [];
  const fields =
    omit(queryParams, ['page', 'pageSize', 'order', 'orderBy', 'query']) || {}; // This storage contains the values of the outer filters

  const numberFields = [];
  const multiFilterFields = ['team', 'assignee', 'status'];
  const fieldNames = {
    team: 'team',
    status: 'status',
    assignee: 'assigneeEmail',
    side: 'side',
    mailboxId: 'mailboxId',
  };

  const getValue = ({ field }) => {
    const fieldValue = queryParams[field];

    if (multiFilterFields.includes(field)) {
      const values = fieldValue?.split(',');
      // Map 'None' to empty string for assignee
      if (field === 'assignee') {
        return values?.map((v) => (v === 'None' ? '' : v));
      }
      return values;
    }

    return numberFields.includes(field) ? Number(fieldValue) : fieldValue;
  };

  const getType = ({ field }) => {
    if (multiFilterFields.includes(field)) {
      return FILTER_RULE_ENUMS.IsAnyOfRuleType;
    }
    return FILTER_RULE_ENUMS.ComparableRuleType;
  };

  const getField = (field) => {
    return fieldNames[field];
  };

  delete fields.side;
  const newFields = pickBy(fields);
  const keys = Object?.keys?.(newFields);

  if (keys?.length) {
    unifiedViewFilterRules = [
      ...keys.map((field) => {
        return {
          field: getField(field),
          operator: FILTER_OPERATOR_ENUMS['='],
          type: getType({ field }),
          value: getValue({ field }),
        };
      }),
    ];
  }

  if (labelsMap[queryParams.side]) {
    unifiedViewFilterRules.push({
      field: 'labels',
      operator: FILTER_OPERATOR_ENUMS['='],
      type: FILTER_RULE_ENUMS.IsAnyOfRuleType,
      value: labelsMap[queryParams.side],
    });
  }
  // special rule for getting unassigned mails
  if (
    queryParams.assignee === '' &&
    queryParams.side === SIDE_FILTERS_ENUM.Unassigned
  ) {
    unifiedViewFilterRules.push({
      field: fieldNames.assignee,
      operator: FILTER_OPERATOR_ENUMS['='],
      type: FILTER_RULE_ENUMS.ComparableRuleType,
      value: '',
    });
  }

  if (payload && payload !== 'undefined') {
    payload = JSON.parse(payload);
    if (payload.value) {
      payload.value = [...payload.value, ...unifiedViewFilterRules];
    } else if (unifiedViewFilterRules?.length) {
      payload = {
        type: 0,
        field: null,
        operator: null,
        value: unifiedViewFilterRules,
      };
    }
  } else if (!payload && unifiedViewFilterRules?.length) {
    payload = {
      type: 0,
      field: null,
      operator: null,
      value: unifiedViewFilterRules,
    };
  } else {
    payload = {
      type: FILTER_RULE_ENUMS.EmptyRuleType,
    };
  }
  return payload;
};

export const handleMailBoxes = (data) => {
  if (!data?.length) return [];
  return data?.map((item) => {
    return {
      value: item?.id,
      text: item?.address,
    };
  });
};

export const handleAssigneesMap = (data) =>
  data.reduce((acc, item) => {
    acc[item.value] = item;
    return acc;
  }, {});

export const handleCommunicationData = (data = []) => {
  if (!data?.length > 0) {
    return [];
  }
  const emails = [];
  data?.forEach((item) => {
    const newEmail = {
      ...item,
      createdAt: item?.createdAt ? formatDate(item?.createdAt, 'MMMM dd') : '',
      updatedAt: item?.updatedAt ? formatDate(item?.updatedAt, 'MMMM dd') : '',
      messageDate: handleEmailListViewDate(item?.messageDate),
      assignee: item?.assignee,
      snippet: removeHtmlTags(item?.snippet),
      displayEmailAddress: getAllDisplayEmailAddress(item),
    };
    emails.push(newEmail);
  });
  return emails;
};
